import type { Bcp47Locale } from '@backmarket/http-api'

export const DATE_FORMAT: Intl.DateTimeFormatOptions = {
  month: 'short',
  day: 'numeric',
  timeZone: 'UTC',
}

export const DATE_FORMAT_SHORT: Intl.DateTimeFormatOptions = {
  day: 'numeric',
  timeZone: 'UTC',
}

export const SHORT_DATE_FORMAT_BY_LOCALE: Partial<
  Record<Bcp47Locale, 'earliest' | 'lastest'>
> = {
  'en-us': 'earliest',
  'en-gb': 'lastest',
  'en-ie': 'lastest',
  'en-au': 'lastest',
  'es-us': 'lastest',
  'fr-fr': 'lastest',
  'fr-be': 'lastest',
  'pt-pt': 'lastest',
  'nl-nl': 'lastest',
  'de-de': 'lastest',
  'it-it': 'lastest',
  'de-at': 'lastest',
  'el-gr': 'lastest',
  'fi-fi': 'lastest',
  'sv-se': 'lastest',
  'sk-sk': 'lastest',
  'es-es': 'lastest',
} as unknown as Partial<Record<Bcp47Locale, 'earliest' | 'lastest'>>
